export const SET_QUIZ_EDITOR_PREV_PATH = '@quizEditor/SET_QUIZ_EDITOR_PREV_PATH';
export const RESET_QUIZ_EDITOR_PREV_PATH = '@quizEditor/RESET_QUIZ_EDITOR_PREV_PATH';

export const SET_SYLLABUS_FORM_VALUES = '@quizEditor/SET_SYLLABUS_FORM_VALUES';
export const SET_COURSE_FORM_VALUES = '@quizEditor/SET_COURSE_FORM_VALUES';
export const SET_CHAPTER_LIST_VALUE = '@quizEditor/SET_CHAPTER_LIST_VALUE';
